import React, { useMemo } from "react";
import { useAppSelector } from "../../redux/configureStore";
import AttendeeRow from "./AttendeeRow";
import { useVenue } from "../api/helpers";
import { getSubscribers } from "../sessions/selectors";
import useSessionId from "../sessions/useSessionId";

const AttendeeList = () => {
  const venue = useVenue();
  const sessionId = useSessionId();
  const subscribers = useAppSelector(getSubscribers(sessionId));

  const attendees = useMemo(() => {
    if (sessionId) {
      return subscribers;
    }
    return venue?.registrants ?? [];
  }, [sessionId, subscribers, venue?.registrants]);

  return (
    <div>
      <div className="attendeeMain">
        {attendees.map((attendee) => (
          <AttendeeRow key={attendee.id} attendee={attendee} />
        ))}
      </div>
      <style jsx>{`
        .attendeeMain {
          display: flex;
          flex-direction: column;
          overflow: auto;
        }
      `}</style>
    </div>
  );
};

export default AttendeeList;
